import React, { useState } from 'react';
import {
  Box,
  Checkbox,
  IconButton,
  InputBase,
  Tooltip,
  Typography,
} from '@mui/material';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

/**
 * One scratchpad item as a full-width row: a checkbox for done, click-to-edit
 * inline text, and a delete button. Mirrors the bet scratchpad's TaskRow, minus
 * the drag handle — item reordering is a later addition. Strikes through when
 * done.
 */
const ListItemRow = ({ item, onToggleDone, onEditContent, onDelete }) => {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(item.content);

  const commitEdit = () => {
    const next = draft.trim();
    setEditing(false);
    if (next && next !== item.content) {
      onEditContent(item, next);
    } else {
      setDraft(item.content);
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.5,
        py: 0.25,
        borderRadius: 1,
        '&:hover': { bgcolor: 'action.hover' },
      }}
    >
      <Checkbox
        size="small"
        checked={item.done}
        onChange={(e) => onToggleDone(item, e.target.checked)}
        sx={{ p: 0.5 }}
      />

      {editing ? (
        <InputBase
          value={draft}
          autoFocus
          fullWidth
          onChange={(e) => setDraft(e.target.value)}
          onBlur={commitEdit}
          onKeyDown={(e) => {
            if (e.key === 'Enter') { e.preventDefault(); commitEdit(); }
            if (e.key === 'Escape') { setDraft(item.content); setEditing(false); }
          }}
          sx={{ flexGrow: 1, fontSize: '0.875rem' }}
        />
      ) : (
        <Typography
          variant="body2"
          onClick={() => { setDraft(item.content); setEditing(true); }}
          sx={{
            flexGrow: 1,
            cursor: 'text',
            color: item.done ? 'text.disabled' : 'text.primary',
            textDecoration: item.done ? 'line-through' : 'none',
            wordBreak: 'break-word',
          }}
        >
          {item.content}
        </Typography>
      )}

      <Tooltip title="Delete item">
        <IconButton size="small" aria-label="Delete item" onClick={() => onDelete(item)}>
          <DeleteOutlineIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default ListItemRow;
